import {
  faInstagram,
  faTiktok,
  faTwitter,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faTicket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DEFAULT_PROJECT_NAMES, LAYOUTS } from "../../constants/general";
import { generateNewIdAndNavigate } from "../../thunks/dashboardThunks";
import { useDispatch } from "react-redux";
import { closeCansvasSizeModal } from "../../store/common/profileModalSlice";

const CanvasSizeModal = ({ onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleReSizeModal = (width, height, layout) => {
    dispatch(
      generateNewIdAndNavigate(
        navigate,
        "/tool/editor/" + "user-template" + "/",
        DEFAULT_PROJECT_NAMES["user-template"],
        false,
        null,
        null,
        null,
        width,
        height,
        layout
      )
    );
    dispatch(closeCansvasSizeModal());
  };
  const selectCanvas = [
    {
      id: 1,
      logo: faYoutube,
      name: "Youtube Video",
      size: "1920 x 1080 (16:9)",
      onClick: () => handleReSizeModal(1920, 1080, LAYOUTS.LANDSCAPE),
      logoColor: "red",
    },
    {
      id: 2,
      logo: faYoutube,
      name: "Youtube Shorts (Beta)",
      size: "720 x 1280px (9:16)",
      onClick: () => handleReSizeModal(720, 1280, LAYOUTS.PORTRAIT),
      logoColor: "red",
    },
    {
      id: 3,
      logo: faTiktok,
      name: "TikTok (Beta)",
      size: "720 x 1280px (9:16)",
      onClick: () => handleReSizeModal(720, 1280, LAYOUTS.PORTRAIT),
    },
    // {
    //   id: 4,
    //   logo: faInstagram,
    //   name: "Instagram Square",
    //   size: "1080 x 1080px (1:1)",
    //   onClick: () => handleReSizeModal(1080, 1080, ),
    // },
    // {
    //   id: 5,
    //   logo: faInstagram,
    //   name: "Instagram Potrait",
    //   size: "864 x 1080px (4:5)",
    //   onClick: () => handleReSizeModal(864, 1080, ),
    // },
    {
      id: 6,
      logo: faXTwitter,
      name: "X (Twitter) Post (Beta)",
      size: "720 x 1280px  (9:16)",
      onClick: () => handleReSizeModal(720, 1280, LAYOUTS.PORTRAIT),
      logoColor: "#000000",
    },
    {
      id: 7,
      logo: faInstagram,
      name: "Instagram Story/Reels (Beta)",
      size: "720 X 1280px (9:16)",
      onClick: () => handleReSizeModal(720, 1280, LAYOUTS.PORTRAIT),
      logoColor: "#e01d72",
    },
    {
      id: 8,
      logo: faInstagram,
      name: "Youtube Video",
      size: "1920 x 1080 (16:9)",
      onClick: () => handleReSizeModal(1920, 1080, LAYOUTS.LANDSCAPE),
      logoColor: "#e01d72",
    },
  ];

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[1001]">
      <div className="absolute inset-0 bg-black opacity-50 "></div>
      <div className="bg-white p-6 rounded-lg w-[1000px] z-[9999] max-h-[400px]">
        <h2 className="text-xl font-bold mb-4">Select Canvas Size</h2>
        <div className="flex gap-4 flex-row flex-wrap justify-evenly item-center">
          {selectCanvas.map((item, index) => (
            <div
              onClick={item.onClick}
              className="flex border  hover:bg-gray-100 rounded-md w-[270px] h-[100px]  border-gray-400 cursor-pointer border-r-3  hover:border-red-400    transition duration-300 p-4 gap-2 flex-row item-center"
            >
              <div className="flex flex-col item-center justify-center  ">
                <FontAwesomeIcon
                  icon={item.logo}
                  size="2xl"
                  style={{ color: item.logoColor }}
                  className="hover:pointer"
                />
              </div>
              <div className="flex flex-col ">
                {" "}
                {/* New div for column layout */}
                <p>{item.name}</p>
                <p>{item.size}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end mt-6">
          <button
            className="border px-4 py-2 rounded hover:bg-gray-200"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CanvasSizeModal;
